module.exports = __webpack_public_path__ + "static/header-video-c1ae4bfb748a0ba6392ad853801166df.mp4";